import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Tracking from './components/Tracking';
import Pricing from './components/Pricing';
import Testimonials from './components/Testimonials';
import ServiceZones from './components/ServiceZones';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import SchemaOrg from '../../components/feature/SchemaOrg';

const homeFaqItems = [
  { question: 'Quels services de transporteur express propose Transporteur Express IDF en Île-de-France ?', answer: 'Transporteur Express IDF est un transporteur express basé en Île-de-France spécialisé dans la livraison urgente de colis, plis et marchandises. Notre service de coursier intervient 24h/24 et 7j/7 pour assurer un transport rapide, sécurisé et direct sans rupture de charge.' },
  { question: 'Comment envoyer un colis urgent avec un coursier en Île-de-France ?', answer: 'Pour envoyer un colis urgent, contactez Transporteur Express IDF, votre transporteur express en Île-de-France. Notre coursier récupère votre colis rapidement et assure une livraison immédiate à Paris et dans toute la région.' },
  { question: 'Quels sont les tarifs d\'un transporteur express en Île-de-France ?', answer: 'Les tarifs d\'un transporteur ou d\'un coursier express varient selon la distance, l\'urgence et le volume. Transporteur Express IDF propose des prix compétitifs en Île-de-France avec devis rapide et transparent.' },
  { question: 'Transport de documents confidentiels par coursier', answer: 'Notre service de transporteur express assure la livraison sécurisée de documents confidentiels en Île-de-France. Chaque coursier garantit une remise en main propre et un suivi précis.' },
  { question: 'Pourquoi choisir un transporteur local en Île-de-France ?', answer: 'Un transporteur local comme Transporteur Express IDF connaît parfaitement la région Île-de-France. Cela permet à notre service de coursier d\'optimiser les trajets et de réduire les délais de livraison.' },
  { question: 'Livraison urgente Paris et région', answer: 'Notre transporteur express intervient à Paris et dans toute l\'Île-de-France pour des livraisons urgentes le jour même. Notre coursier prend en charge vos colis immédiatement après validation.' }
];

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <SchemaOrg type="home" faqItems={homeFaqItems} />
      <Navbar />
      <Hero />
      <Services />
      <Tracking />
      <Pricing />
      <Testimonials />
      <ServiceZones />
      <FAQ />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
